import { FunctionComponent } from "react";

import { Accordion, Alert, AlertIcon, Box, Text } from "@chakra-ui/react";
import { WidgetLoading } from "am-tax-fe-core";

import { ConversationResponse } from "../../api";
import { useRequestConversations } from "../../api/apiQueries";

import ConversationItem from "./ConversationItem";

interface Props {
    engagementId: string;
    projectId?: string;
    requestId: string;
    conversations: ConversationResponse[];
}

const CoversationList: FunctionComponent<Props> = (props: Props) => {
    const { engagementId, projectId, requestId, conversations } = props;
    const { isPending, isError, error } = useRequestConversations(requestId, engagementId, projectId);

    if (isPending) {
        return <WidgetLoading />;
    }

    if (isError) {
        return (
            <Alert my=".5rem" status="error" variant="solid">
                <AlertIcon />
                {error.message}
            </Alert>
        );
    }

    return conversations && conversations.length > 0 ? (
        <Accordion allowToggle reduceMotion defaultIndex={0}>
            {conversations.map((conversation: ConversationResponse, i: number) => (
                <ConversationItem key={i} conversation={conversation} engagementId={engagementId} projectId={projectId} />
            ))}
        </Accordion>
    ) : (
        <Box>
            <Text>There are no conversations for the request yet. Start a new conversation by pressing the button at the bottom of the screen.</Text>
        </Box>
    );
};

export default CoversationList;
